import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../../Router/all_routes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setToogleHeader } from "../../../core/redux/action";
import {
  ArrowLeft,
  ChevronDown,
  ChevronUp,
  Eye,
  Info,
  LifeBuoy,
  List,
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import "sweetalert2/dist/sweetalert2.min.css";
import apiHandler from "../../common/api";
import DatePickup from "../../components/DatePickup/DatePickup";
import moment from "moment";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import BusinessHours from "../../components/BusinessHours/BusinessHours";
import config, { frontendUrl, Imageurl, NoImage } from "../../../config";
import BusinessHoursByDate from "../../components/BusinessHours/BusinessHoursByDate";
import { useCheckUserPermission } from "../../common/userPermission";
import CommonTextEditor from "../../components/Editor/CommonTextEditor";
import BusinessHoursTeamShiftManage from "../../components/BusinessHours/BusinessHoursTeamShiftManage";
import { Country, State, City } from "country-state-city";
import { imgpathgenerator } from "../../../core/Common/imgpathgenerator";
import { isValidAustralianPhoneNumber } from "../../common/common";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";
import AddService from "../Service/AddService";
import { ArrowRight } from "feather-icons-react/build/IconComponents";
import AddTeam from "../Business/AddTeam";
import { TeamData } from "../../../core/json/Team_Data";
import { setTeamValue } from "../../../core/redux/action";
import ServiceMenuModal from "../../../core/modals/applications/ServicemenuModal";

const getAddressFromCoordinates = async (lat, lon) => {
  const url = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`;
  try {
    const response = await fetch(url);
    const data = await response.json();
    if (data.error) {
      throw new Error("Address not found");
    }
    return data; // Return formatted address
  } catch (error) {
    console.error("Error fetching address:", error);
    return null;
  }
};

const BusinessOnboarding = ({ isDisable = false }) => {
  const route = all_routes;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const allCountries = Country.getAllCountries();
  const [options, setOptions] = useState({
    gender: [],
    countries: allCountries.map((c) => ({
      value: c.name,
      label: c.name,
    })),
  });

  const MySwal = withReactContent(Swal);
  const location = useLocation();
  const parts = location.pathname;
  let pathname = parts?.trim()?.split("/");
  let businessId = pathname[2] || 0;
  const formServiceValue = useSelector((state) => state.ServiceValue);
  const [uploadImage, setUploadImage] = useState(null);
  const user_data = useSelector((state) => state.user_data);
  const userData = useSelector((state) => state.user_data);
  const ID = userData?.id;
  console.log(businessId, "check login user ID");
  const data = useSelector((state) => state.toggle_header);
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );
  const Today = moment().format("YYYY-MM-DD");
  const [imageGallery, setImageGallery] = useState([]);
  const [uploadimage, setuplodaimg] = useState([]);
  const [formvalue, setformvalue] = useState({
    businessUniqueName: "",
    businessName: "",
    businessLogo: "",
    businessCategory: 0,
    businessDescription: "",
    businessAddress: "",
    country: "",
    state: "",
    city: "",
    zipcode: "",
    openingDate: Today,
    phoneNumber: "",
    emailAddress: "",
    whatsappNumber: "",
    websiteURL: "",
    socialLinks: "",
    permissiontemplate: 4,
    permissionsid: "",
    marketviews: 0,
    password: "",
    confirmpassword: "",
    ID: 0,
    loginUser: ID,
    QRCodeUrl: "",
    GoogleMapUrl: "",
    ManuUrl: "",
    AppoimentUrl: "",
    OnlineOrderUrl: "",
    TermAndCondition: "",
    HealthAndSafetyAttributes: "",
    AccessibilityFeatures: "",
    AboutAs: "",
    businessFranchise: "",
    businessNameisValid: "Invalid",
    anyoneEmailAddress: "",
    anyonePhoneNumber: "",
    phoneNumberError: "",
    whatsappNumberError: "",
    anyonePhoneNumberError: "",
    isProvideHomeService: 0,
    StripeCustomerId: ""
  });
  const [Categorylist, setCategorylist] = useState([]);



  console.log(formvalue, Categorylist, "formvalue8789798749848");
  console.log(imageGallery, "imageGallery");
  // const [Categorylist, setCategorylist] = useState([]);
  const [permissiontemplates, setpermissiontemplates] = useState([]);
  const [hearAbout, sethearAbout] = useState([]);
  const [errors, seterrors] = useState("");
  const [businessList, setBusinessList] = useState([]);
  const [zipcodeList, setZipcodeList] = useState([]);
  const [filteredZipcodeList, setFilteredZipcodeList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isChange, setIsChange] = useState(0);
  // const isProvideHomeService = [
  //   { value: 0, label: "No" },
  //   { value: 1, label: "Yes" },
  // ];
  const [isServiceMenuOpen, setIsServiceMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isTeamOpen, setIsTeamOpen] = useState(false);

  const TeamFormValue = useSelector((state) => state.TeamValue);
  console.log(TeamFormValue, "410501TeamValue");

  const [uploadFile, setUploadFile] = useState(null);

  console.log(imageGallery, "imageGallery456000");

  const defaultBusinessHours = [
    {
      id: 0,
      dayId: 1,
      dayName: "Monday",
      startTime: "09:00",
      endTime: "18:00",
      isDayOff: 0,
    },
    {
      id: 0,
      dayId: 2,
      dayName: "Tuesday",
      startTime: "09:00",
      endTime: "18:00",
      isDayOff: 0,
    },
    {
      id: 0,
      dayId: 3,
      dayName: "Wednesday",
      startTime: "09:00",
      endTime: "18:00",
      isDayOff: 0,
    },
    {
      id: 0,
      dayId: 4,
      dayName: "Thursday",
      startTime: "09:00",
      endTime: "18:00",
      isDayOff: 0,
    },
    {
      id: 0,
      dayId: 5,
      dayName: "Friday",
      startTime: "09:00",
      endTime: "18:00",
      isDayOff: 0,
    },
    {
      id: 0,
      dayId: 6,
      dayName: "Saturday",
      startTime: "09:00",
      endTime: "18:00",
      isDayOff: 0,
    },
    {
      id: 0,
      dayId: 7,
      dayName: "Sunday",
      startTime: "09:00",
      endTime: "18:00",
      isDayOff: 0,
    },
  ];
  //business hours
  const [daysDropdown, setDaysDropdown] = useState([]);
  const [minHoursDropdown, setMinHoursDropdown] = useState([]);
  const [businessHours, setBusinessHours] = useState(defaultBusinessHours);
  const [businessTypeList, setBusinessTypeList] = useState([]);
  const [staffApiRefresh, setStaffApiRefresh] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [confirmShowPassword, setConfirmShowPassword] = useState(false);
  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const handleToggleConfirmPassword = () => {
    setConfirmShowPassword((prevShowPassword) => !prevShowPassword);
  };

  useEffect(() => {
    if (
      (userData?.roleID === 3 && businessId == 0) ||
      (userData?.roleID != 1 && businessId != userData?.businessId)
    ) {
      navigate(route?.BusinessOnboarding + "/" + userData?.businessId);
    }
  }, [userData, businessId]);

  useEffect(() => {
    if (formvalue.country) {
      const statesData = State.getStatesOfCountry(
        allCountries.find((c) => c.name === formvalue.country)?.isoCode
      );
      setOptions((prev) => ({
        ...prev,
        states: statesData.map((s) => ({
          value: s.name,
          label: s.name,
        })),
      }));

      // If editing with a pre-filled state, fetch cities right away
      if (formvalue.state) {
        const cities = City.getCitiesOfState(
          allCountries.find((c) => c.name === formvalue.country)?.isoCode,
          statesData.find((s) => s.name === formvalue.state)?.isoCode
        );

        setOptions((prev) => ({
          ...prev,
          cities: cities.map((c) => ({
            value: c.name,
            label: c.name,
          })),
        }));
      }
    }
  }, [formvalue.country, formvalue.state]);

  console.log(formvalue, "formvalue");

  const Validation = (formvalues) => {
    let error = {};

    if (!formvalues.businessName) {
      error.businessName = "Business Name is Required ";
    }
    if (formvalues.isProvideHomeService == null) {
      error.isProvideHomeService = "Provide Home Service is Required ";
    }

    if (!formvalues.businessUniqueName) {
      error.businessUniqueName = "Business Unique Name is Required ";
    }

    if (errors.businessValidName) {
      error.businessValidName = errors.businessValidName;
    }

    if (
      businessId == 0 &&
      formvalues.businessUniqueName &&
      formvalues?.businessNameisValid === "Invalid"
    ) {
      error.businessUniqueName =
        "Please click on Business Unique Name Validate button";
    }

    if (!formvalues.businessCategory) {
      error.businessCategory = " Business Type is Required";
    }

    if (
      formvalue.phoneNumber &&
      !isValidAustralianPhoneNumber(formvalue.phoneNumber)
    ) {
      error.phoneNumber =
        "Please enter a valid Australian mobile number (e.g., 614XXXXXXXX).";
    }

    if (
      formvalue.whatsappNumber &&
      !isValidAustralianPhoneNumber(formvalue.whatsappNumber)
    ) {
      error.whatsappNumber =
        "Please enter a valid Australian whatsapp number (e.g., 614XXXXXXXX).";
    }

    if (
      formvalue.anyonePhoneNumber &&
      !isValidAustralianPhoneNumber(formvalue.anyonePhoneNumber)
    ) {
      error.anyonePhoneNumber =
        "Please enter a valid Australian anyone number (e.g., 614XXXXXXXX).";
    }

    if (!formvalues.permissiontemplate) {
      error.permissiontemplate = "Subscription Plan is Required";
    }

    if (businessId == 0) {
      if (!formvalues.password) {
        error.password = "Password is Required";
      }
    }

    if (formvalues.password && formvalues.password?.length < 6) {
      error.password = "Password Must be more than 6 digit ";
    }

    if (
      formvalues.password &&
      formvalues.password !== formvalues.confirmpassword
    ) {
      error.confirmpassword = " Confirm Password is Not Same as Password";
    }

    if (!formvalues.zipcode) {
      error.zipcode = "ZipCod is Required";
    }

    return error;
  };

  const handleLocationClick = async () => {
    // Requesting the user's current location using Geolocation API
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;
        const fetchedAddress = await getAddressFromCoordinates(
          latitude,
          longitude
        );

        if (fetchedAddress?.display_name) {
          const zipCode = zipcodeList?.find(
            (el) => el.value == fetchedAddress?.address?.postcode
          );
          setformvalue({
            ...formvalue,
            ["businessAddress"]: fetchedAddress?.display_name,
            country: fetchedAddress?.address?.country,
            state: fetchedAddress?.address?.state,
            city: fetchedAddress?.address?.state_district,
            zipcode: zipCode ? zipCode?.value : "",
          });
        } else {
          // setAddress("Unable to fetch address");
          setformvalue({
            ...formvalue,
            ["businessAddress"]: "Unable to get address",
          });
        }
      });
    } else {
      setformvalue({
        ...formvalue,
        ["businessAddress"]: "Geolocation is not supported by this browser.",
      });
    }
  };

  const ValidateName = async () => {
    if (formvalue.businessUniqueName == "") {
      seterrors({
        ...errors,
        businessUniqueName: "Enter Name Properly ",
      });
      return;
    }
    const response = await apiHandler({
      method: "GET",
      route: `Superadmin/ValidateName?Name=${formvalue.businessUniqueName}`,
    });

    if (response.ResponseData[0]?.ID == 1) {
      console.log(response.ResponseData[0]?.ID, "124data");
      seterrors({
        ...errors,
        businessUniqueName: "Valid Name",
      });
      setformvalue((prevState) => ({
        ...prevState,
        businessNameisValid: "Valid",
      }));
    } else {
      seterrors({
        ...errors,
        businessUniqueName: "Invalid Name",
      });
    }
  };

  // const HandleChange = (e) => {
  //   const { name, value } = e.target || {}; // Handle both input and WYSIWYG editor

  //   setformvalue((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));

  //   if (name === "businessUniqueName") {
  //     setformvalue((prevState) => ({
  //       ...prevState,
  //       businessNameisValid: "Invalid",
  //     }));
  //   }
  // };

  //   const sanitizePhoneNumber = (number) => {
  //   if (!number) return "";
  //   return number.replace(/\s+/g, ""); // remove spaces
  // };

  // ✅ Format DB phone numbers into readable format
  // Format number for display (with spaces and +61)
  const formatDBPhoneNumber = (number) => {
    if (!number) return "";

    // Ensure it starts with +61
    let cleaned = number.replace(/\D/g, ""); // remove non-digits
    if (cleaned.startsWith("61")) {
      cleaned = "+" + cleaned;
    } else if (cleaned.startsWith("0")) {
      cleaned = "+61" + cleaned.substring(1);
    } else if (!cleaned.startsWith("+61")) {
      cleaned = "+61" + cleaned;
    }

    // Remove + for formatting spaces, but keep for final output
    const noPlus = cleaned.replace("+", "");

    // Format: +61 4 1234 5678
    return "+" + noPlus.replace(/^61(\d)(\d{4})(\d{4})$/, "61 $1 $2 $3");
  };

  // ✅ Utility: Validate Australian phone number (mobile or landline)
  const isValidAustralianPhoneNumbercust = (number) => {
    const digits = number.replace(/\D/g, ""); // remove non-digits
    const mobilePattern = /^61[4]\d{8}$/; // Mobile
    const landlinePattern = /^61[2378]\d{8}$/; // Landline
    const testPattern = /^61[5]\d{8}$/; // If you also want 5xx (test case you gave)

    return (
      mobilePattern.test(digits) ||
      landlinePattern.test(digits) ||
      testPattern.test(digits)
    );
  };

  // ✅ HandleChange function (progressive formatting with spaces)
  // const HandleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "phoneNumber") {
  //     let digits = value.replace(/\D/g, ""); // keep only digits

  //     // If starts with 0 → replace with 61
  //     if (digits.startsWith("0")) {
  //       digits = "61" + digits.slice(1);
  //     }

  //     // Force "61" prefix
  //     if (!digits.startsWith("61")) {
  //       digits = "61" + digits;
  //     }

  //     // Limit to 11 digits (61 + 9 more)
  //     digits = digits.slice(0, 11);

  //     let formatted = "+" + digits;

  //     // Progressive formatting with spaces
  //     if (digits.length <= 2) {
  //       formatted = "+" + digits;
  //     } else if (digits.length === 3) {
  //       formatted = `+${digits.slice(0, 2)} ${digits.slice(2)}`;
  //     } else if (digits.length <= 7) {
  //       formatted = `+${digits.slice(0, 2)} ${digits.slice(2, 3)} ${digits.slice(3)}`;
  //     } else if (digits.length <= 11) {
  //       formatted = `+${digits.slice(0, 2)} ${digits.slice(2, 3)} ${digits.slice(
  //         3,
  //         7
  //       )} ${digits.slice(7)}`;
  //     }

  //     setformvalue((prev) => ({
  //       ...prev,
  //       [name]: formatted,
  //     }));
  //   } else {
  //     setformvalue((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  //   }
  // };

  const HandleChange = (e) => {
    const { name, value } = e.target;

    // Password handling
    if (name.trim() === "password") {
      setIsChange(1);
    }

    // Phone number formatting
    if (name === "phoneNumber") {
      let digits = value.replace(/\D/g, "");

      if (digits.startsWith("0")) digits = "61" + digits.slice(1);
      if (!digits.startsWith("61")) digits = "61" + digits;
      digits = digits.slice(0, 11);

      let formatted = "+" + digits;

      if (digits.length <= 2) formatted = "+" + digits;
      else if (digits.length === 3)
        formatted = `+${digits.slice(0, 2)} ${digits.slice(2)}`;
      else if (digits.length <= 7)
        formatted = `+${digits.slice(0, 2)} ${digits.slice(
          2,
          3
        )} ${digits.slice(3)}`;
      else if (digits.length <= 11)
        formatted = `+${digits.slice(0, 2)} ${digits.slice(
          2,
          3
        )} ${digits.slice(3, 7)} ${digits.slice(7)}`;

      setformvalue((prev) => ({ ...prev, [name]: formatted }));
      return;
    }

    // Other fields
    setformvalue((prev) => ({ ...prev, [name]: value }));
  };






  const handleDateChange = (e, label) => {
    console.log(e, "selectedDate", label);
    if (e) {
      setformvalue({ ...formvalue, [label]: e });
    }
  };

  // const Handleselect = (e, label) => {
  //   if (label == "permissiontemplate") {
  //     setformvalue({
  //       ...formvalue,
  //       [label]: e.value,
  //       ["permissionsid"]: e.permissions,
  //     });
  //   } else {
  //     setformvalue({
  //       ...formvalue,
  //       [label]: e.value,
  //     });
  //   }
  // };
  const Handleselect = (e, label) => {
    if (label === "permissiontemplate") {
      setformvalue({
        ...formvalue,
        [label]: e.value,
        permissionsid: e.permissions,
      });
    } else if (label === "businessFranchise") {
      const selectedIds = e.map((item) => item.value).join(",");
      setformvalue({
        ...formvalue,
        [label]: selectedIds,
      });
    } else {
      setformvalue({
        ...formvalue,
        [label]: e ? e.value : "",
      });
    }
  };

  const Handlefile = (e, field) => {
    if (field === "businessLogo") {
      let file = e.target.files[0];
      const fileURL = URL.createObjectURL(file);
      setformvalue({
        ...formvalue,
        ["businessLogo"]: imgpathgenerator(file.name, pathname[1]) || "",
        ["uniquefileName"]:
          JSON.stringify([imgpathgenerator(file.name, pathname[1])]) || "[]",
        dirname: `${pathname[1]}`,
        files: file,
        [`businessLogoPreview`]: fileURL,
      });
    }
  };

  const handlemultiplefile = (e) => {
    let fileList = e.target.files;

    const filesArray = Array.from(fileList).map((file) => {
      // const timestamp = Date.now();
      // const originalName = file.name.split(".").slice(0, -1).join("."); // Remove extension
      // const extension = file.name.split(".").pop(); // Get extension

      // Replace spaces with dashes in original file name
      // const sanitizedFileName = originalName.trim().replace(/\s+/g, "-");

      // Final file name: original-name_timestamp.extension
      // const newFileName = `${sanitizedFileName}_${timestamp}.${extension}`;
      const newFileName = imgpathgenerator(file?.name, "businessOnboarding");

      const renamedFile = new File([file], newFileName, {
        type: file.type,
        lastModified: file.lastModified,
      });

      return {
        file: renamedFile,
        previewUrl: URL.createObjectURL(renamedFile),
        ID: 0,
      };
    });

    setImageGallery((prevFiles) => [...prevFiles, ...filesArray]);
    setuplodaimg((prevFiles) => [...prevFiles, ...filesArray]);

    // const filesArray = Array.from(fileList).map((file) => ({
    //   file,
    //   previewUrl: URL.createObjectURL(file),
    //   ID: 0,
    // }));

    // setImageGallery((prevFiles) => [...prevFiles, ...filesArray]);
    // setuplodaimg((prevFiles) => [...prevFiles, ...filesArray]);
  };

  console.log(uploadimage, "uploadimage");

  // const handleupload = async () => {
  //   try {
  //     if (!uploadimage?.length) {
  //       console.error("No images to upload.");
  //       return;
  //     }

  //     const formData = new FormData();
  //     uploadimage.forEach((file) => {
  //       formData.append("files", file);
  //     });

  //     formData.append("dirname", "businessOnboarding");
  //     formData.append("businessId", userData.businessId);
  //     formData.append("userId", userData.id);

  //     let uniquefileName = uploadimage?.map((file) => ({
  //       path: imgpathgenerator(file.name, "businessOnboarding"),
  //       uniquefileName: imgpathgenerator(file.name, "businessOnboarding"),
  //       ID: 0,
  //     }));

  //     formData.append("uniquefileName", JSON.stringify(uniquefileName));

  //     const response = await apiHandler({
  //       method: "POST",
  //       route: "Business/businessgalleryUpload",
  //       payload: formData,
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });

  //     console.log(response);

  //     setImageGallery(response?.ResponseData);
  //   } catch (error) {
  //     console.error("Upload error:", error);
  //   }
  // };



  const handleupload = async () => {
    try {
      if (!uploadimage?.length) {
        MySwal.fire({
          icon: 'warning',
          title: 'No Images',
          text: 'Please select images to upload first.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      const formData = new FormData();

      // Append all image files
      uploadimage.forEach((file) => {
        formData.append("files", file.file);
      });

      // Generate unique file names for each file
      const uniqueFileNames = uploadimage.map((file) => file?.file?.name);

      // Append other form data
      formData.append("dirname", "businessOnboarding");
      formData.append("businessId", businessId);
      formData.append("userId", userData.id);
      formData.append("uniquefileName", JSON.stringify(uniqueFileNames));

      // Make API call
      const response = await apiHandler({
        method: "POST",
        route: "Business/businessgalleryUpload",
        payload: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("Upload response:", response);

      // Update gallery with response data
      if (response?.ResponseData) {
        setImageGallery(response.ResponseData);
        setuplodaimg([]);

        // Success toast
        MySwal.fire({
          icon: 'success',
          title: 'Upload Successful!',
          text: `${uploadimage.length} image(s) uploaded successfully.`,
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      } else {
        // If response doesn't have expected data
        MySwal.fire({
          icon: 'error',
          title: 'Upload Failed',
          text: 'Something went wrong with the upload.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Upload error:", error);

      // Error toast
      MySwal.fire({
        icon: 'error',
        title: 'Upload Error',
        text: 'Failed to upload images. Please try again.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
    }
  };

  const handleRemoveImage = (item, index) => {
    setImageGallery(imageGallery.filter((_, i) => i !== index));

    if (item?.ID == 0) {
      setuplodaimg(
        uploadimage.filter((el) => el.previewUrl != item.previewUrl)
      );
    }

    if (item?.ID > 0) {
      deleteUploadGalleryByID(item?.ID);
    }
  };

  const deleteUploadGalleryByID = async (id) => {
    const response = await apiHandler({
      method: "POST",
      route: "Business/businessgalleryimagedeletebyid",
      payload: { id, loginUserId: ID },
    });

    console.log("Delete response:", response);

    // Update gallery with response data
    if (response?.ResponseID > 0) {
      console.log("Media is Deleted " + response?.ResponseID);
    }
  };

  const hasPermission = useCheckUserPermission(route.BusinessOnboardList);

  const HandleSubmit = async (e) => {
    e.preventDefault();

    if (uploadimage?.length > 0) {
      Swal.fire({
        position: "top-end",
        icon: "warning",
        title: "Unuploaded Images",
        text: "Please upload the selected images in the Business Gallery before saving.",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }

    const formErrors = Validation(formvalue);
    seterrors(formErrors);

    if (businessId == 0) {
      if (errors == "") {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: `Fill All Required Fields`,
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
    }
    if (Object.keys(formErrors).length > 0) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: "Please fix the errors",
        html: Object.values(formErrors)
          .map((error) => `<div>${error}</div>`)
          .join(""),
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }
    console.log(formErrors, "errors", "formErrors");

    // return;
    const payload = {
      ...formvalue,
      // phoneNumber: sanitizePhoneNumber(formvalue.phoneNumber),
      // whatsappNumber: sanitizePhoneNumber(formvalue.whatsappNumber),
      businessHours: JSON.stringify(businessHours),
      loginUserId: ID,
      imageGallery: imageGallery,
      isPasswordChange: isChange,
    };
    setLoading(true);

    const response = await apiHandler({
      method: "POST",
      route: "Superadmin/BusinessOnboardingUpsert",
      payload: payload,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.ResponseCode === "SUCCESS") {
      setLoading(false);
      if (businessId === 0 && response?.ResponseID > 0) {
        navigate(
          `${route?.signin}?user=${formvalue?.businessUniqueName}&pwd=${formvalue?.password}&email=${formvalue?.emailAddress}`
        );
        return;
      } else {
        getBusinessDetailById(response?.ResponseID);
      }
      MySwal.fire({
        title: businessId > 0 ? "Business Updated!" : "Business Added!",
        text:
          businessId > 0
            ? "The business details have been successfully updated."
            : "The business has been successfully added.",
        className: "btn btn-success",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn btn-success",
        },
      }).then((result) => {
        if (result.isConfirmed && hasPermission) {
          navigate(route.BusinessOnboardList);
        }
      });
      // navigate(route.BusinessListingMaster);
    } else {
      setLoading(false);
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: `${response.ResponseMessage}`,
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };



  const prodcutDataListApi = async () => {
    // const response = await apiHandler({
    //   method: "GET",
    //   route: "Business/CategoryAll",
    // });
    // if (response.ResponseCode === "SUCCESS") {
    //   console.log(response, "data");
    //   setCategorylist(response.ResponseData);
    // } else {
    //   console.log(response, "data");
    // }

    const response = await apiHandler({
      method: "GET",
      route: `Business/CategoryAll?businessId=${userData?.businessId}`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      const category = response.ResponseData?.map((u) => ({
        value: u.ID,
        label: u.categoryName,
      }));
      setCategorylist(category);
    } else {
      console.log(response, "data");
    }

    const responses = await apiHandler({
      method: "GET",
      route: "auth/getpermissiontemplates",
    });
    if (responses.ResponseCode === "SUCCESS") {
      // console.log(responses, "data");
      const filterOnlySubscribetemp = responses.ResponseData?.filter(
        (el) => el.isSubscription == 1 || el.id == 4
      );
      setpermissiontemplates(filterOnlySubscribetemp);

      // if (formvalue?.ID === 0) {
      //   setformvalue({
      //     ...formvalue,
      //     permissionsid: filterOnlySubscribetemp?.find(
      //       (el) => el.id == formvalue?.permissiontemplate
      //     )?.permissions,
      //   });
      // }

      if (formvalue?.ID === 0) {
        setformvalue((prev) => {
          const matchedTemplate = filterOnlySubscribetemp?.find(
            (el) => el.id == prev.permissiontemplate
          );
          return {
            ...prev,
            permissionsid: matchedTemplate?.permissions ?? "",
          };
        });
      }

      // else{
      //    setformvalue({
      //   ...formvalue,
      //   permissionsid: filterOnlySubscribetemp?.find(el => el.id == formvalue?.permissiontemplate)?.permissionsid,
      // });
      // }
    } else {
      console.log(responses, "data");
    }

    const businesslistdata = await apiHandler({
      method: "GET",
      route: "Business/getbusinesslistoption",
    });
    if (responses.ResponseCode === "SUCCESS") {
      console.log(responses, "data");
      setBusinessList(
        businesslistdata.ResponseData[0].map((el) => ({
          label: el.businessName,
          value: el.ID,
        }))
      );
    } else {
      console.log(responses, "data");
    }

    const responss = await apiHandler({
      method: "GET",
      route: "Superadmin/hearAboutAll",
    });
    if (responss.ResponseCode === "SUCCESS") {
      console.log(responss, "data");
      sethearAbout(responss.ResponseData);
    } else {
      console.log(responss, "data");
    }
    // add get full hours for dropdown
    const multipleTablesData = await apiHandler({
      method: "GET",
      route: "Business/getMultipleTablesData",
      payload: { tableNames: "days,timeIntervals,businessType" }, // make sure dont add space in the string and its correct.
    });
    if (multipleTablesData.ResponseCode === "SUCCESS") {
      console.log(multipleTablesData, "multipleTablesData");
      setDaysDropdown(multipleTablesData.ResponseData[0]);

      const formatData = multipleTablesData.ResponseData[1].map((hours) => ({
        ...hours,
        label: hours.timeLabel,
        value: hours.timeValue,
      }));

      console.log(formatData, "formatData 7ds7d8s7d8s78d");


      setMinHoursDropdown(formatData);
      // if (businessId == 0) {
      //   setBusinessHours(
      //     multipleTablesData.ResponseData[0].map((day) => ({
      //       id: 0,
      //       dayId: day.id,
      //       dayName: day.dayName,
      //       startTime: "09:00",
      //       endTime: "18:00",
      //       isDayOff: 0, // Default to working day
      //     }))
      //   );
      // }

      const businessTypes = multipleTablesData.ResponseData[2].map((type) => ({
        ...type,
        label: type.businessTypeName,
        value: type.ID,
      }));

      setBusinessTypeList(businessTypes);
    } else {
      console.log(multipleTablesData, "data");
    }
  };

  const getBusinessDetailById = async (bId) => {
    const response = await apiHandler({
      method: "GET",
      route: `Business/getbusinessdetailbyid?businessId=${bId || 0}`,
    });
    if (response.ResponseCode === "SUCCESS") {
      const businessData = response.ResponseData[0][0];
      setformvalue((prev) => ({
        ...prev,
        ...businessData,
        isProvideHomeService: Number(businessData.isProvideHomeService),
        StripeCustomerId: businessData?.StripeCustomerId == null ? '' : businessData?.StripeCustomerId
      }));

      const businessHoursData = response.ResponseData[1];
      const mediamaster = response.ResponseData[2];
      console.log(mediamaster, "25463");
      console.log(businessData, "businessData");
      console.log(businessHoursData, "businessHoursData 789");

      setImageGallery(mediamaster);
      setBusinessHours(businessHoursData);
    } else {
      console.log(response, "data");
    }
  };

  const getZipCodeAllowList = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Superadmin/zipCodeMasterAll`,
    });
    if (response.ResponseCode === "SUCCESS") {
      const data = response.ResponseData?.map((el) => {
        return {
          label: el.zipCode,
          value: el.zipCode,
          isActive: el.isActive,
          country: el.country,
          state: el.state,
          city: el.city,
        };
      })?.filter((el) => el.isActive == 1);
      setZipcodeList(data);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    getZipCodeAllowList();
    prodcutDataListApi();
    if (businessId > 0) {
      getBusinessDetailById(businessId);
    }
  }, [businessId]);

  useEffect(() => {
    const filterZipCode = zipcodeList?.filter(
      (el) =>
        el.city === formvalue?.city &&
        el.country === formvalue?.country &&
        el.state === formvalue?.state
    );
    setFilteredZipcodeList(filterZipCode);
  }, [formvalue]);

  // const category = Categorylist?.map((u) => ({
  //   value: u.ID,
  //   label: u.categoryName,
  // }));

  const permissiontemplateoption = permissiontemplates?.map((u) => ({
    label: u.Name,
    permissions: u.permissions,
    value: u.value,
  }));

  const hearAboutOption = hearAbout?.map((u) => ({
    label: u.Label,
    value: u.ID,
  }));
  console.log(errors, "errors");

  console.log(daysDropdown, minHoursDropdown, "minHoursDropdown");

  // State for business hours
  // Handle change
  // const handleChange = (dayId, field, value) => {
  //   setBusinessHours((prev) =>
  //     prev.map((item) =>
  //       item.dayId === dayId ? { ...item, [field]: value } : item
  //     )
  //   );
  // };

  const handleBusinessHoursChange = (updatedHours) => {
    setBusinessHours(updatedHours);
    console.log("Updated Business Hours:", updatedHours); // Debugging output
  };

  console.log(businessHours, "businessHours");

  const getStaffWiseScheduleRefresh = async () => {
    setStaffApiRefresh(!staffApiRefresh);
  };

  const businessOnNordingPermmision = useCheckUserPermission(
    route.BusinessOnboarding
  );

  const customStyles = {
    multiValue: (styles) => ({
      ...styles,
      backgroundColor: "#FF9F43",
      color: "white",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      color: "white",
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: "white",
      ":hover": {
        backgroundColor: "darkred",
        color: "white",
      },
    }),
  };

  const handleClearImage = () => {
    setformvalue((prevState) => ({
      ...prevState,
      businessLogoPreview: "",
      businessLogo: "",
      file: "",
    }));
  };

  function isValidUsername(username) {
    const regex = /^[a-zA-Z0-9._]+$/;
    return regex.test(username);
  }

  const HandleServiceSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (
      formServiceValue?.serviceName == "" ||
      formServiceValue?.serviceType == 0 ||
      formServiceValue?.menuCategoryID == 0
    ) {
      let message = "";
      if (formServiceValue?.serviceName == "") {
        message = " Please Enter Service name ";
      } else if (formServiceValue?.serviceType == 0) {
        message = " Please select Service Type  ";
      } else if (formServiceValue?.menuCategoryID == 0) {
        message = " Please select Service Menu  ";
      }

      Swal.fire({
        position: "top-end",
        icon: "error",
        title: message,
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    let priceDuration = formServiceValue?.Pricingandduration?.filter(
      (el) => el.Price > 0
    );

    let TeamDatavalue = formServiceValue?.Team?.filter(
      (el) => el.Ischecked == true
    );

    let priceDurationData = {};
    priceDurationData.PricinganddurationXml = priceDuration;
    let priceDurationDataString = JSON.stringify(priceDurationData);

    let TeamData = {};
    TeamData.TeamXml = TeamDatavalue;
    let TeamDataString = JSON.stringify(TeamData);

    const response = await apiHandler({
      method: "POST",
      route: "Business/businessServiceUpsert",
      payload: {
        ...formServiceValue,
        BusinessId: businessId,
        loginuserid: user_data.id,
        Pricingandduration: priceDurationDataString,
        Team: TeamDataString,
        files: uploadImage,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.ResponseCode === "SUCCESS") {
      setLoading(false);
      MySwal.fire({
        title: "Service Added!",
        text: "The Service has been successfully added.",
        className: "btn btn-success",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn btn-success",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          // navigate(route.ServiceList);
          setIsServicesOpen(false)
        }
      });
    } else {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: `${response.ResponseMessage}`,
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  const HandleTeamSubmit = async (e) => {
    e.preventDefault();

    if (
      TeamFormValue?.FirstName == "" ||
      TeamFormValue?.Email == "" ||
      (TeamFormValue?.ContactNumber &&
        !isValidAustralianPhoneNumber(TeamFormValue?.ContactNumber)) ||
      TeamFormValue?.RoleID == 0 ||
      TeamFormValue?.PassWord == "" ||
      TeamFormValue?.PassWord !== TeamFormValue.ConformPassword
    ) {
      let message = "";
      if (TeamFormValue?.FirstName == "") {
        message = " Please Enter Full Name  ";
      } else if (TeamFormValue?.Email == "") {
        message = " Please select Email  ";
      } else if (
        TeamFormValue?.ContactNumber &&
        !isValidAustralianPhoneNumber(TeamFormValue?.ContactNumber)
      ) {
        message = ` ${TeamFormValue?.ContactNumberError} `;
      } else if (TeamFormValue?.RoleID == 0) {
        message = " Please select RoleID ";
      } else if (TeamFormValue?.PassWord == "") {
        message = " Please Enter Valid  PassWord  ";
      } else if (TeamFormValue?.PassWord !== TeamFormValue.ConformPassword) {
        message = " Password and Confirm Password Must Be same   ";
      }

      Swal.fire({
        position: "top-end",
        icon: "error",
        title: message,
        showConfirmButton: false,
        timer: 1500,
      });
      return;
    }

    let Emergencydata = {};
    Emergencydata.emergencyXml = TeamFormValue.EmergencyContact;
    let EmergencydataString = JSON.stringify(Emergencydata);
    let filterservice = TeamFormValue.Serviceandcommision?.filter(
      (el) => el.Ischecked == true
    );

    let ServiceData = {};
    ServiceData.serviceXml = filterservice;
    let ServiceDataString = JSON.stringify(ServiceData);

    setLoading(true);
    const response = await apiHandler({
      method: "POST",
      route: "Business/businessTeamUpsert",
      payload: {
        ...TeamFormValue,
        BusinessId: businessId,
        BusinessUniqueName: formvalue.businessName,
        loginuserid: user_data.id,
        files: uploadFile,
        EmergencyContact: EmergencydataString,
        Serviceandcommision: ServiceDataString,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.ResponseCode === "SUCCESS") {
      setLoading(false);
      MySwal.fire({
        title: "Team Added!",
        text: "The Team has been successfully added.",
        className: "btn btn-success",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn btn-success",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(setTeamValue(TeamData));
          setIsTeamOpen(false)
          // navigate(route.StaffListing);
        }
      });
      // navigate(route.BusinessListingMaster);
    } else {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: `${response.ResponseMessage}`,
        showConfirmButton: false,
        timer: 1500,
      });
    }
    setLoading(false);
  };

  const handleTeamChangeFile = (file) => {
    setUploadFile(file);
  };

  const fetchServiceData = async () => {
    try {
      const serviceData = await apiHandler({
        method: "GET",
        route: `Business/TeamserviceData?BusinessID=${user_data.businessId}`,
      });

      if (serviceData?.ResponseCode !== "SUCCESS") {
        console.error("Failed to fetch team list:", serviceData);
        return;
      }

      let Teamdata = serviceData?.ResponseData?.map((el) => ({
        ...el,
        Ischecked: true,
        serviceId: el.serviceId,
        ID: 0,
      }));


      dispatch(
        setTeamValue({
          ...TeamData,
          Serviceandcommision: Teamdata,
        })
      );

      // console.log(pathname[1], params.ID, "412563");
      // if (params.ID > 0) {
      //   const findByIdResponse = await apiHandler({
      //     method: "GET",
      //     route: `Business/TeamfindbyID?ID=${params.ID}`,
      //   });

      //   if (findByIdResponse?.ResponseCode !== "SUCCESS") {
      //     console.error("Failed to fetch service details:", findByIdResponse);
      //     return;
      //   }

      //   const basicDetails =
      //     findByIdResponse?.ResponseData?.Teamdata?.[0] || {};
      //   const EmergencyContact =
      //     findByIdResponse?.ResponseData?.EmergencyContact || [];

      //   const teamData = findByIdResponse?.ResponseData?.Service || [];

      //   let teamMap = {};
      //   teamData.forEach((team) => {
      //     teamMap[team?.serviceId] = {
      //       ID: team?.ID,
      //       staffCommision: team?.staffCommision,
      //       homeServicePrice: team?.homeServicePrice || "",
      //     };
      //   });

      //   let Teamdata = serviceData?.ResponseData?.map((el) => ({
      //     ...el,
      //     category: el?.category,
      //     name: el?.name,
      //     price: el?.price,
      //     duration: el?.duration,
      //     priceType: el?.priceType,
      //     Ischecked: teamMap[el.serviceId]?.ID > 0,
      //     serviceId: el.serviceId,
      //     ID: teamMap[el.serviceId]?.ID || 0,
      //     commission: teamMap[el?.serviceId]?.staffCommision,
      //     homeServicePrice: teamMap[el?.serviceId]?.homeServicePrice,
      //   }));

      //   const updatedServiceValue = {
      //     profile: basicDetails?.image,
      //     FirstName: basicDetails?.fullName,
      //     LastName: "",
      //     // LastName: basicDetails?.fullName,
      //     Email: basicDetails?.email,
      //     PassWord: basicDetails?.passwordHash,
      //     ConformPassword: basicDetails?.passwordHash,
      //     ContactNumber: basicDetails?.phoneNumber,
      //     RoleID: basicDetails?.roleID,
      //     designation: basicDetails?.designation,
      //     CalendorColorID: basicDetails?.calendarcolor,
      //     Address1: basicDetails?.add1,
      //     Address2: basicDetails?.add2,
      //     Country: basicDetails?.country,
      //     State: basicDetails?.state,
      //     City: basicDetails?.city,
      //     ZipCode: basicDetails?.zipcode,
      //     ID: basicDetails?.id,
      //     EmergencyContact: EmergencyContact.map((el) => ({
      //       fullName: el.fullName,
      //       email: el.email,
      //       relationship: el.relation,
      //       phoneNumber: el.phoneNumber,
      //       Id: el.ID,
      //     })),
      //     Serviceandcommision: Teamdata,
      //   };
      //   console.log(updatedServiceValue, "databasic");
      //   dispatch(setTeamValue(updatedServiceValue));
      // }
    } catch (error) {
      console.error("Error fetching service data:", error);
    }
  };

  useEffect(() => {
    console.log("hit use effect ");
    fetchServiceData();
    console.log("hit use effect 1");
  }, []);
  return (
    <>
      <LoadingSpinner isLoading={loading} />
      <div className="page-wrapper">
        {isServiceMenuOpen && (
          <ServiceMenuModal
            isOpen={isServiceMenuOpen}
            setIsOpen={setIsServiceMenuOpen}
            businessId={businessId}
            callBack={() => fetchServiceData()}

          />
        )}
        {isServicesOpen && (
          <div
            className={`modal d-block show`}
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Create Service </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsServicesOpen(false)}
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  <AddService
                    isFromOnboarding={1}
                    setUploadImage={setUploadImage}
                  />
                  <div className="content">
                    {/* <div className="row page-header justify-content-between">
                          <div className="col-md-6"></div>
                        </div> */}
                    {/* Moved buttons to the end of .content */}

                    <div className="d-flex justify-content-end mb-4">
                      <button onClick={() => setIsServicesOpen(false)} className="btn btn-outline-primary btn-sm me-2">
                        Cancel
                      </button>
                      <button
                        onClick={HandleServiceSubmit}
                        className="8 btn btn-primary btn-md btn-wave me-2 "
                      >
                        Save
                        <ArrowRight />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {isTeamOpen && (
          <div
            className={`modal d-block show`}
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Create Team</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsTeamOpen(false)}
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body">
                  <AddTeam
                    handleChangeFile={handleTeamChangeFile}
                    isFromOnboarding={1}
                  />
                  <div className="col-md-12 p-4 d-flex justify-content-end">
                    <button
                      onClick={() => setIsTeamOpen(false)}
                      className="btn btn-primary btn-md btn-wave me-2"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={HandleTeamSubmit}
                      className="btn btn-outline-primary btn-md me-2"
                    >
                      Save
                      {/* <ArrowRight /> */}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title title-color">
                <h4> Onboard New Business</h4>
                <h6>Create new Business</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {formvalue?.ID > 0 && (
                <li>
                  <div className="page-btn d-flex align-items-center gap-2">
                    <button
                      onClick={() =>
                        window.open(
                          `${frontendUrl}/${formvalue?.businessUniqueName}`,
                          "_blank"
                        )
                      }
                      className="btn btn-outline-primary btn-md text-nowrap"
                    >
                      <Eye className="me-2" />
                      View Business
                    </button>

                    <a
                      href={route.businessSubscription}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary btn-md text-nowrap"
                    >
                      Subscribe Now
                    </a>
                  </div>
                </li>
              )}
              {useCheckUserPermission(route.BusinessOnboardList) && (
                <li>
                  <div className="page-btn">
                    <button
                      onClick={() => navigate(route.BusinessOnboardList)}
                      className="7 btn btn-primary btn-md btn-wave me-2"
                    >
                      <ArrowLeft className="me-2 custome-white-color" />
                      Back to Business
                    </button>
                  </div>
                </li>
              )}
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Collapse"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp className="feather-chevron-up" />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          {/* /add */}
          <form onSubmit={HandleSubmit}>
            <div className="card">
              <div className="card-body add-product pb-0">
                <div
                  className="accordion-card-one accordion"
                  id="accordionExample"
                >
                  {/* first Business Basic Details */}
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingOne">
                      <div
                        className="accordion-button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <div className="addproduct-icon">
                          <h5>
                            <Info className="add-info" />
                            <span>Business Information</span>
                          </h5>
                          <div className="d-flex align-items-center gap-2">
                            <span className="step-text">Step 1</span>
                            <ChevronDown className="chevron-down-add" />
                          </div>
                          {/* <Link to="#">
                            <ChevronDown className="chevron-down-add" />
                          </Link> */}
                        </div>
                      </div>
                    </div>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <div className="addservice-info">
                          <div className="row">
                            <div className="container my-3">
                              <div className="card custome-card-padding rounded-2 mb-0">
                                <div className="row align-items-center">
                                  {/* /* Image Preview */}
                                  <div className="col-auto">
                                    {/* Hidden file input for image click */}
                                    <input
                                      type="file"
                                      name="businessLogo"
                                      className="d-none"
                                      ref={(input) =>
                                        (window.businessLogoInput = input)
                                      }
                                      onChange={(e) =>
                                        Handlefile(e, "businessLogo")
                                      }
                                    />
                                    <img
                                      src={
                                        formvalue?.businessLogoPreview
                                          ? formvalue.businessLogoPreview
                                          : formvalue?.businessLogo
                                            ? config.Imageurl +
                                            formvalue.businessLogo
                                            : NoImage
                                      }
                                      alt="Business Logo"
                                      className="custome-image rounded-circle"
                                      width="80"
                                      height="80"
                                      style={{
                                        objectFit: "cover",
                                        cursor: isDisable
                                          ? "default"
                                          : "pointer",
                                      }}
                                      onClick={() => {
                                        if (
                                          !isDisable &&
                                          window.businessLogoInput
                                        ) {
                                          window.businessLogoInput.click();
                                        }
                                      }}
                                      onError={(e) => {
                                        e.currentTarget.src =
                                          "https://mock.sonarpos.com/static/media/noimage.4ab3885dec12ad76c627.png";
                                      }}
                                    />
                                  </div>

                                  {/* Label and Info */}
                                  <div className="col-auto">
                                    <h6 className="mb-0 fw-bold">
                                      Upload Profile Image
                                    </h6>
                                    <small className="text-color-70">
                                      Image should be below 500 kb
                                    </small>
                                  </div>

                                  {/* Buttons */}
                                  <div className="col-auto d-flex gap-3 ms-auto">
                                    {!isDisable && (
                                      <>
                                        {/* <input
                                        type="file"
                                        name="businessLogo"
                                        className="form-control fs-18"
                                        // style={{ maxWidth: '200px' }}
                                        onChange={(e) =>
                                          Handlefile(e, "businessLogo")
                                        }
                                      /> */}
                                        <button
                                          type="button"
                                          className="btn btn-outline-primary btn-sm me-2"
                                          onClick={handleClearImage} // implement this if needed
                                        >
                                          Cancel
                                        </button>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="container my-3">
                              <div className="row">
                                <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                  <div className="mb-3">
                                    <div className="d-flex justify-content-between">
                                      <label className="form-label">
                                        Business Type{" "}
                                        <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <a
                                        // className="form-lable"
                                        target="_blank"
                                        href="/businessType"
                                      >
                                        Create Type
                                      </a>
                                    </div>
                                    <Select
                                      classNamePrefix="react-select"
                                      options={businessTypeList}
                                      name="businessCategory"
                                      value={businessTypeList?.find(
                                        (el) =>
                                          el.value == formvalue.businessCategory
                                      )}
                                      onChange={(e) =>
                                        Handleselect(e, "businessCategory")
                                      }
                                      placeholder="Choose"
                                      isDisabled={isDisable}
                                      styles={{ height: "40px" }}
                                    />
                                    {errors.businessCategory && (
                                      <div style={{ color: "red" }}>
                                        {errors.businessCategory}
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Business Name{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      name="businessName"
                                      className="form-control"
                                      value={formvalue.businessName}
                                      onChange={HandleChange}
                                      readOnly={isDisable}
                                    />
                                    {errors.businessName && (
                                      <div style={{ color: "red" }}>
                                        {errors.businessName}
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                  <div className="row">
                                    <div className="col-md-8 mb-3">
                                      <label className="form-label">
                                        Business Unique Name{" "}
                                        <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <input
                                        type="text"
                                        name="businessUniqueName"
                                        className="form-control"
                                        value={formvalue.businessUniqueName}
                                        // onChange={HandleChange}
                                        onChange={(e) => {
                                          HandleChange(e);
                                          const username = e.target.value;
                                          if (!isValidUsername(username)) {
                                            seterrors((prevErrors) => ({
                                              ...prevErrors,
                                              businessValidName:
                                                "Usernames can only use letters, numbers, underscores and periods.",
                                            }));
                                          } else {
                                            seterrors((prevErrors) => ({
                                              ...prevErrors,
                                              businessValidName: "",
                                            }));
                                          }
                                        }}
                                        readOnly={businessId > 0 || isDisable}
                                      />
                                      {errors.businessUniqueName && (
                                        <div
                                          style={{
                                            color:
                                              errors.businessUniqueName ===
                                                "Valid Name"
                                                ? "green"
                                                : "red",
                                          }}
                                        >
                                          {errors.businessUniqueName}
                                        </div>
                                      )}
                                      {errors.businessValidName && (
                                        <div
                                          style={{
                                            color: "red",
                                          }}
                                        >
                                          {errors.businessValidName}
                                        </div>
                                      )}
                                    </div>
                                    {businessId == 0 && (
                                      <div className="col-md-3 mt-4">
                                        <button
                                          type="button"
                                          className="btn btn-outline-primary btn-md me-2"
                                          onClick={ValidateName}
                                        >
                                          Validate
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  Business Description {"(Optional)"}
                                </label>
                                <textarea
                                  type="text"
                                  name="businessDescription"
                                  className="form-control"
                                  value={formvalue.businessDescription}
                                  onChange={HandleChange}
                                  readOnly={isDisable}
                                />
                              </div>
                            </div>
                            {/* Business Address */}
                          </div>

                          <div className="custome-border-bottom row">
                            <div className="w-100">
                              <div className="row d-flex align-items-center">
                                <div className="col-xxl-10 col-xl-9 col-lg-9 col-md-6 col-sm-6 col-6 mb-3">
                                  <label className="form-label">
                                    Business Address
                                    {
                                      " ( Click on 'Get Address' button to get the address from your IP location. ) "
                                    }
                                  </label>
                                  <input
                                    type="text"
                                    name="businessAddress"
                                    className="form-control"
                                    value={formvalue.businessAddress}
                                    onChange={HandleChange}
                                    readOnly={isDisable}
                                  />
                                </div>
                                {isDisable ? (
                                  false
                                ) : (
                                  <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6">
                                    <button
                                      style={{ height: "40px" }}
                                      type="button"
                                      className="d-flex align-items-center ms-auto btn btn-primary mt-1"
                                      onClick={handleLocationClick}
                                    >
                                      Get Address
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="d-flex row">
                              <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div className="mb-3">
                                  <div className="d-flex justify-content-between">
                                    <label className="form-label">
                                      Country
                                    </label>
                                  </div>
                                  <Select
                                    classNamePrefix="react-select"
                                    options={options?.countries}
                                    name="country"
                                    value={options?.countries?.find(
                                      (el) => el.value == formvalue.country
                                    )}
                                    onChange={(e) => {
                                      Handleselect(e, "country");
                                      setFilteredZipcodeList([]);
                                    }}
                                    placeholder="Choose Country"
                                    isDisabled={isDisable}
                                  />
                                </div>
                              </div>

                              <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div className="mb-3">
                                  <div className="d-flex justify-content-between">
                                    <label className="form-label">State</label>
                                  </div>
                                  <Select
                                    classNamePrefix="react-select"
                                    options={options?.states}
                                    name="state"
                                    value={options?.states?.find(
                                      (el) => el.value == formvalue.state
                                    )}
                                    onChange={(e) => {
                                      Handleselect(e, "state");
                                      setFilteredZipcodeList([]); // Reset filtered Postcodes when state changes
                                    }}
                                    placeholder="Choose State"
                                    isDisabled={
                                      isDisable ? isDisable : !formvalue.country
                                    }
                                  />
                                </div>
                              </div>

                              <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div className="mb-3">
                                  <div className="d-flex justify-content-between">
                                    <label className="form-label">City</label>
                                  </div>
                                  <Select
                                    classNamePrefix="react-select"
                                    options={options?.cities}
                                    name="city"
                                    value={options?.cities?.find(
                                      (el) => el.value == formvalue.city
                                    )}
                                    onChange={(e) => Handleselect(e, "city")}
                                    placeholder="Choose City"
                                    isDisabled={
                                      isDisable ? isDisable : !formvalue.state
                                    }
                                  />
                                </div>
                              </div>

                              <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div className="mb-3">
                                  <div className="d-flex flex-column">
                                    <div>
                                      <label className="form-label">
                                        Zipcode{" "}
                                      </label>
                                      <span style={{ color: "red" }}>*</span>
                                    </div>
                                  </div>
                                  <Select
                                    classNamePrefix="react-select"
                                    options={filteredZipcodeList}
                                    name="zipcode"
                                    value={filteredZipcodeList?.find(
                                      (el) => el.value == formvalue.zipcode
                                    )}
                                    onChange={(e) => Handleselect(e, "zipcode")}
                                    placeholder="Choose Zipcode"
                                    isClearable={true}
                                    isDisabled={
                                      isDisable ? isDisable : !formvalue.city
                                    }
                                  />
                                  <label className="text-color-70">
                                    Note: We are only serving in this location
                                    at this moment
                                  </label>
                                  {errors.zipcode && (
                                    <div style={{ color: "red" }}>
                                      {errors.zipcode}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Login Module */}
                          <div className="mt-3 row pb-4 custome-border-bottom">
                            <h5>Login Detail</h5>
                            {/* Email Address */}
                            <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  Email Address{" "}
                                </label>
                                <input
                                  type="email"
                                  name="emailAddress"
                                  className="form-control"
                                  value={formvalue.emailAddress}
                                  onChange={HandleChange}
                                  readOnly={isDisable}
                                />
                              </div>
                            </div>
                            <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                              <label className="form-label">
                                Password
                                {businessId == 0 && (
                                  <span style={{ color: "red" }}>*</span>
                                )}
                              </label>
                              <div className="pass-group">
                                <input
                                  type={showPassword ? "text" : "password"}
                                  name="password"
                                  className="form-control"
                                  value={formvalue.password}
                                  onChange={HandleChange}
                                  // onFocus={(e) => (e.target.value = "")} // Clear input on focus
                                  readOnly={isDisable}
                                  autoComplete="new-password" // Prevent autofill
                                />
                                <span
                                  className={`fas toggle-password ${showPassword ? "fa-eye" : "fa-eye-slash"
                                    }`}
                                  onClick={handleTogglePassword}
                                />
                              </div>
                              {errors.password && (
                                <div style={{ color: "red" }}>
                                  {errors.password}
                                </div>
                              )}
                            </div>

                            <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                              <label className="form-label">
                                Confirm Password
                                {businessId == 0 && (
                                  <span style={{ color: "red" }}>*</span>
                                )}
                              </label>
                              <div className="pass-group">
                                <input
                                  type={
                                    confirmShowPassword ? "text" : "password"
                                  }
                                  name="confirmpassword"
                                  className="form-control"
                                  value={formvalue.confirmpassword}
                                  onChange={HandleChange}
                                  readOnly={isDisable}
                                />
                                <span
                                  className={`fas toggle-password ${confirmShowPassword
                                    ? "fa-eye"
                                    : "fa-eye-slash"
                                    }`}
                                  onClick={handleToggleConfirmPassword}
                                />
                                {errors.confirmpassword && (
                                  <div style={{ color: "red" }}>
                                    {errors.confirmpassword}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Suscription Module  */}
                          <div className="mt-3 row pb-4">
                            <h5>Subscription</h5>
                            <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  Subscription Plan
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <Select
                                  classNamePrefix="react-select"
                                  options={permissiontemplateoption}
                                  name="permissiontemplate"
                                  value={permissiontemplateoption?.find(
                                    (el) =>
                                      el.value == formvalue.permissiontemplate
                                  )}
                                  onChange={(e) =>
                                    Handleselect(e, "permissiontemplate")
                                  }
                                  placeholder="Choose"
                                  isDisabled={isDisable || formvalue?.ID > 0}
                                />
                                {errors.permissiontemplate && (
                                  <div style={{ color: "red" }}>
                                    {errors.permissiontemplate}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  How did you hear about BookYarra? {"(Optional)"}
                                </label>
                                <Select
                                  classNamePrefix="react-select"
                                  options={hearAboutOption}
                                  name="marketviews"
                                  value={hearAboutOption?.find(
                                    (el) => el.value == formvalue.marketviews
                                  )}
                                  onChange={(e) =>
                                    Handleselect(e, "marketviews")
                                  }
                                  placeholder="Choose"
                                  isDisabled={isDisable}
                                />
                              </div>
                            </div>
                            <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  Do you provide home service?
                                </label>
                                <div className="d-flex gap-3">
                                  <div className="form-check">
                                    <input
                                      type="radio"
                                      className="form-check-input"
                                      id="isProvideHomeServiceYes"
                                      name="isProvideHomeService"
                                      value={1}
                                      checked={
                                        formvalue.isProvideHomeService === 1
                                      }
                                      onChange={(e) =>
                                        setformvalue({
                                          ...formvalue,
                                          isProvideHomeService: Number(
                                            e.target.value
                                          ),
                                        })
                                      }
                                      disabled={isDisable}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="provideHomeServiceYes"
                                    >
                                      Yes
                                    </label>
                                  </div>

                                  <div className="form-check">
                                    <input
                                      type="radio"
                                      className="form-check-input"
                                      id="isProvideHomeService"
                                      name="isProvideHomeService"
                                      value={0}
                                      checked={
                                        formvalue.isProvideHomeService === 0
                                      }
                                      onChange={(e) =>
                                        setformvalue({
                                          ...formvalue,
                                          isProvideHomeService: Number(
                                            e.target.value
                                          ),
                                        })
                                      }
                                      disabled={isDisable}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="isProvideHomeServiceNo"
                                    >
                                      No
                                    </label>
                                  </div>
                                </div>
                                {/* {error.isProvideHomeService && (
      <span className="text-danger">{error.isProvideHomeService}</span>
    )} */}
                              </div>
                            </div>
                          </div>

                          {businessId === 0 &&
                            (isDisable ? (
                              false
                            ) : (
                              <div className="col-lg-12">
                                <div className="btn-addproduct mb-4">
                                  {businessOnNordingPermmision && (
                                    <button
                                      type="submit"
                                      className="btn btn-submit btn-md"
                                    >
                                      Save Business
                                    </button>
                                  )}
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  {businessId > 0 && (
                    <>
                      {/* Add Service Menu */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingTwo">
                          <div
                            className="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="true"
                            aria-controls="collapseTwo"
                          >
                            <div className="addproduct-icon">
                              <h5>
                                <Info className="add-info" />
                                <span>Add Service Menu</span>
                              </h5>
                              <div className="d-flex align-items-center gap-2">
                                <span className="step-text">Step 2</span>
                                <ChevronDown className="chevron-down-add" />
                              </div>
                              {/* <Link to="#">
                                <ChevronDown className="chevron-down-add" />
                              </Link> */}
                            </div>
                          </div>
                        </div>
                        <div
                          id="collapseTwo"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <div className="addservice-info">
                              <div className="row">
                                <div className="container my-3">
                                  <div className="card custome-card-padding rounded-2 mb-0">
                                    <div className="row align-items-center">
                                      <div className="d-flex gap-3 w-100 mb-3 mt-2 flex-wrap">
                                        <div
                                          style={{ width: "fit-content" }}
                                          className=""
                                        >
                                          <button
                                            style={{ height: "40px" }}
                                            type="button"
                                            className="d-flex align-items-center ms-auto btn btn-primary mt-1"
                                            onClick={() =>
                                              setIsServiceMenuOpen(true)
                                            }
                                          >
                                            Add Service Menu
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Add Service */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingThree">
                          <div
                            className="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="true"
                            aria-controls="collapseThree"
                          >
                            <div className="addproduct-icon">
                              <h5>
                                <Info className="add-info" />
                                <span>Add Service</span>
                              </h5>
                              <div className="d-flex align-items-center gap-2">
                                <span className="step-text">Step 3</span>
                                <ChevronDown className="chevron-down-add" />
                              </div>
                              {/* <Link to="#">
                                <ChevronDown className="chevron-down-add" />
                              </Link> */}
                            </div>
                          </div>
                        </div>
                        <div
                          id="collapseThree"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <div className="addservice-info">
                              <div className="row">
                                <div className="container my-3">
                                  <div className="card custome-card-padding rounded-2 mb-0">
                                    <div className="row align-items-center">
                                      <div className="d-flex gap-3 w-100 mb-3 mt-2 flex-wrap">
                                        <div
                                          style={{ width: "fit-content" }}
                                          className=""
                                        >
                                          <button
                                            style={{ height: "40px" }}
                                            type="button"
                                            className="d-flex align-items-center ms-auto btn btn-primary mt-1"
                                            onClick={() =>
                                              setIsServicesOpen(true)
                                            }
                                          >
                                            Add Services
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Add Team */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingFour">
                          <div
                            className="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFour"
                            aria-expanded="true"
                            aria-controls="collapseFour"
                          >
                            <div className="addproduct-icon">
                              <h5>
                                <Info className="add-info" />
                                <span>Add Team</span>
                              </h5>
                              <div className="d-flex align-items-center gap-2">
                                <span className="step-text">Step 4</span>
                                <ChevronDown className="chevron-down-add" />
                              </div>
                              {/* <Link to="#">
                                <ChevronDown className="chevron-down-add" />
                              </Link> */}
                            </div>
                          </div>
                        </div>
                        <div
                          id="collapseFour"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingFour"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <div className="addservice-info">
                              <div className="row">
                                <div className="container my-3">
                                  <div className="card custome-card-padding rounded-2 mb-0">
                                    <div className="row align-items-center">
                                      <div className="d-flex gap-3 w-100 mb-3 mt-2 flex-wrap">
                                        <div
                                          style={{ width: "fit-content" }}
                                          className=""
                                        >
                                          <button
                                            style={{ height: "40px" }}
                                            type="button"
                                            className="d-flex align-items-center ms-auto btn btn-primary mt-1"
                                            onClick={() => setIsTeamOpen(true)}
                                          >
                                            Add Team
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Contact Information */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingFive">
                          <div
                            className="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFive"
                            aria-expanded="true"
                            aria-controls="collapseFive"
                          >
                            <div className="text-editor add-list">
                              <div className="addproduct-icon list icon">
                                <h5>
                                  <LifeBuoy className="add-info" />
                                  <span>Contact Information {"(Optional)"} </span>
                                </h5>
                                <div className="d-flex align-items-center gap-2">
                                <span className="step-text">Step 5</span>
                                <ChevronDown className="chevron-down-add" />
                              </div>
                                {/* <Link to="#">
                                  <ChevronDown className="chevron-down-add" />
                                </Link> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="collapseFive"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingFive"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <div className="row">
                              {/* phoneNumber Number */}
                              <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Phone Number
                                  </label>
                                  <input
                                    type="text" // must be text to allow + and spaces
                                    name="phoneNumber"
                                    className="form-control"
                                    placeholder="Add Number After +61"
                                    value={
                                      formatDBPhoneNumber(
                                        formvalue.phoneNumber
                                      ) || ""
                                    }
                                    onChange={(e) => {
                                      let raw = e.target.value.replace(
                                        /\D/g,
                                        ""
                                      ); // keep only digits

                                      // Replace leading 0 with 61
                                      if (raw.startsWith("0"))
                                        raw = "61" + raw.slice(1);

                                      // Ensure prefix 61
                                      if (!raw.startsWith("61"))
                                        raw = "61" + raw;

                                      // Max 11 digits
                                      raw = raw.slice(0, 11);

                                      // Update form state (raw number only, no spaces)
                                      setformvalue((prev) => ({
                                        ...prev,
                                        phoneNumber: "+" + raw,
                                      }));
                                    }}
                                    readOnly={isDisable}
                                    onBlur={() => {
                                      if (
                                        formvalue.phoneNumber &&
                                        !isValidAustralianPhoneNumbercust(
                                          formvalue.phoneNumber
                                        )
                                      ) {
                                        setformvalue((prev) => ({
                                          ...prev,
                                          phoneNumberError:
                                            "Please enter a valid Australian Phone Number (e.g., +61 4XX XXX XXX or +61 2 XXXX XXXX).",
                                        }));
                                      } else {
                                        setformvalue((prev) => ({
                                          ...prev,
                                          phoneNumberError: "",
                                        }));
                                      }
                                    }}
                                  />
                                  {formvalue.phoneNumberError && (
                                    <span className="text-danger">
                                      {formvalue.phoneNumberError}
                                    </span>
                                  )}
                                </div>
                              </div>

                              <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    WhatsApp Number
                                  </label>
                                  <input
                                    type="text" // must be text to allow + and spaces
                                    name="whatsappNumber"
                                    className="form-control"
                                    placeholder="Add Number After +61"
                                    value={
                                      formatDBPhoneNumber(
                                        formvalue.whatsappNumber
                                      ) || ""
                                    }
                                    onChange={(e) => {
                                      let raw = e.target.value.replace(
                                        /\D/g,
                                        ""
                                      ); // keep only digits

                                      // Replace leading 0 with 61
                                      if (raw.startsWith("0"))
                                        raw = "61" + raw.slice(1);

                                      // Ensure prefix 61
                                      if (!raw.startsWith("61"))
                                        raw = "61" + raw;

                                      // Max 11 digits
                                      raw = raw.slice(0, 11);

                                      // Update form state (raw number only, no spaces)
                                      setformvalue((prev) => ({
                                        ...prev,
                                        whatsappNumber: "+" + raw,
                                      }));
                                    }}
                                    readOnly={isDisable}
                                    onBlur={() => {
                                      if (
                                        formvalue.whatsappNumber &&
                                        !isValidAustralianPhoneNumbercust(
                                          formvalue.whatsappNumber
                                        )
                                      ) {
                                        setformvalue((prev) => ({
                                          ...prev,
                                          whatsappNumberError:
                                            "Please enter a valid Australian WhatsApp number (e.g., +61 4XX XXX XXX or +61 2 XXXX XXXX).",
                                        }));
                                      } else {
                                        setformvalue((prev) => ({
                                          ...prev,
                                          whatsappNumberError: "",
                                        }));
                                      }
                                    }}
                                  />
                                  {formvalue.whatsappNumberError && (
                                    <span className="text-danger">
                                      {formvalue.whatsappNumberError}
                                    </span>
                                  )}
                                </div>
                              </div>

                              {/* WhatsApp Number */}
                              {/* <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    WhatsApp Number
                                  </label>
                                  <input
                                    type="number"
                                    name="whatsappNumber"
                                    className="form-control"
                                    value={formvalue.whatsappNumber}
                                    onChange={HandleChange}
                                    readOnly={isDisable}
                                    onBlur={() => {
                                      if (
                                        formvalue.whatsappNumber &&
                                        !isValidAustralianPhoneNumber(
                                          formvalue.whatsappNumber
                                        )
                                      ) {
                                        setformvalue({
                                          ...formvalue,
                                          whatsappNumberError:
                                            "Please enter a valid Australian whatsapp number (e.g., 614XXXXXXXX).",
                                        });
                                      } else {
                                        setformvalue({
                                          ...formvalue,
                                          whatsappNumberError: "",
                                        });
                                      }
                                    }}
                                  />
                                  {formvalue.whatsappNumberError && (
                                    <span className="text-danger">
                                      {formvalue.whatsappNumberError}
                                    </span>
                                  )}
                                </div>
                              </div> */}
                            </div>
                            <div className="row pb-4">
                              {/* Website URL */}
                              <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Website URL
                                  </label>
                                  <input
                                    type="text"
                                    name="websiteURL"
                                    className="form-control"
                                    value={formvalue.websiteURL}
                                    onChange={HandleChange}
                                    readOnly={isDisable}
                                  />
                                </div>
                              </div>
                              {/* Social Media Links */}
                              {/* <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Social Media Links
                                  </label>
                                  <input
                                    type="text"
                                    name="socialLinks"
                                    className="form-control"
                                    value={formvalue.socialLinks}
                                    onChange={HandleChange}
                                    readOnly={isDisable}
                                  />
                                </div>
                              </div> */}

                              <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Opening Date{" "}
                                  </label>
                                  <DatePickup
                                    filterDate={formvalue.openingDate}
                                    handleDateChange={(e) =>
                                      handleDateChange(
                                        moment(e).format("YYYY-MM-DD"),
                                        "openingDate"
                                      )
                                    }
                                    disabled={isDisable}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Email Setup for Anyone Profile  */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingSix">
                          <div
                            className="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseSix"
                            aria-expanded="true"
                            aria-controls="collapseSix"
                          >
                            <div className="text-editor add-list">
                              <div className="addproduct-icon list icon">
                                <h5>
                                  <LifeBuoy className="add-info" />
                                  <span>

                                    Set Business manage email for anyone profile </span>
                                </h5>
                                <div className="d-flex align-items-center gap-2">
                                  <span className="step-text">Step 6</span>
                                  <ChevronDown className="chevron-down-add" />
                                </div>
                                {/* <Link to="#">
                                  <ChevronDown className="chevron-down-add" />
                                </Link> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="collapseSix"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingSix"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <div className="row pb-5">
                              <div className="mt-3 row pb-4 custome-border-bottom">
                                {/* Anyone Email */}
                                <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Anyone Email Address{" "}
                                    </label>
                                    <input
                                      type="email"
                                      name="anyoneEmailAddress"
                                      className="form-control"
                                      value={formvalue.anyoneEmailAddress}
                                      onChange={HandleChange}
                                      readOnly={isDisable}
                                    />
                                  </div>
                                </div>
                                {/* <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                  <label className="form-label">
                                    Anyone Phone Number{" "}
                                  </label>
                                  <div className="pass-group">
                                    <input
                                      type="number"
                                      name="anyonePhoneNumber"
                                      className="form-control"
                                      value={formvalue.anyonePhoneNumber}
                                      onChange={HandleChange}
                                      readOnly={isDisable}
                                      onBlur={() => {
                                        if (
                                          formvalue.anyonePhoneNumber &&
                                          !isValidAustralianPhoneNumber(
                                            formvalue.anyonePhoneNumber
                                          )
                                        ) {
                                          setformvalue({
                                            ...formvalue,
                                            anyonePhoneNumberError:
                                              "Please enter a valid Australian anyone number (e.g., 614XXXXXXXX).",
                                          });
                                        } else {
                                          setformvalue({
                                            ...formvalue,
                                            anyonePhoneNumberError: "",
                                          });
                                        }
                                      }}
                                    />
                                    {formvalue.anyonePhoneNumberError && (
                                      <span className="text-danger">
                                        {formvalue.anyonePhoneNumberError}
                                      </span>
                                    )}
                                  </div>
                                </div> */}

                                <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Anyone Phone Number{" "}
                                    </label>
                                    <input
                                      type="text" // must be text to allow + and spaces
                                      name="anyonePhoneNumber"
                                      className="form-control"
                                      value={
                                        formatDBPhoneNumber(
                                          formvalue.anyonePhoneNumber
                                        ) || ""
                                      }
                                      onChange={(e) => {
                                        let raw = e.target.value.replace(
                                          /\D/g,
                                          ""
                                        ); // keep only digits

                                        // Replace leading 0 with 61
                                        if (raw.startsWith("0"))
                                          raw = "61" + raw.slice(1);

                                        // Ensure prefix 61
                                        if (!raw.startsWith("61"))
                                          raw = "61" + raw;

                                        // Max 11 digits
                                        raw = raw.slice(0, 11);

                                        // Update form state (raw number only, no spaces)
                                        setformvalue((prev) => ({
                                          ...prev,
                                          anyonePhoneNumber: "+" + raw,
                                        }));
                                      }}
                                      readOnly={isDisable}
                                      onBlur={() => {
                                        if (
                                          formvalue.anyonePhoneNumber &&
                                          !isValidAustralianPhoneNumbercust(
                                            formvalue.anyonePhoneNumber
                                          )
                                        ) {
                                          setformvalue((prev) => ({
                                            ...prev,
                                            anyonePhoneNumberError:
                                              "Please enter a valid Australian anyone number (e.g., 614XXXXXXXX).",
                                          }));
                                        } else {
                                          setformvalue((prev) => ({
                                            ...prev,
                                            anyonePhoneNumberError: "",
                                          }));
                                        }
                                      }}
                                    />
                                    {formvalue.anyonePhoneNumberError && (
                                      <span className="text-danger">
                                        {formvalue.anyonePhoneNumberError}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Contact info */}
                      {/* <div className="accordion-item">
                  <div className="accordion-header" id="heading3">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse3"
                      aria-expanded="true"
                      aria-controls="collapse3"
                    >
                      <div className="text-editor add-list">
                        <div className="addproduct-icon list">
                          <h5>
                            <List className="add-info" />
                            <span> Login Details </span>
                          </h5>
                          <Link to="#">
                            <ChevronDown className="chevron-down-add" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapse3"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading3"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="row">
                     
                      </div>
                    </div>
                  </div>
                </div> */}

                      {/* BusinessGallery */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingTen">
                          <div
                            className="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTen"
                            aria-expanded="true"
                            aria-controls="collapseTen"
                          >
                            <div className="text-editor add-list">
                              <div className="addproduct-icon list">
                                <h5>
                                  <List className="add-info" />
                                  <span>Business Gallery {"(Optional)"}</span>
                                </h5>
                                <div className="d-flex align-items-center gap-2">
                                  <span className="step-text">Step 7</span>
                                  <ChevronDown className="chevron-down-add" />
                                </div>
                                {/* <Link to="#">
                                  <ChevronDown className="chevron-down-add" />
                                </Link> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="collapseTen"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingTen"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <div className="row pb-4">
                              <div className="card col-lg-12 col-sm-12 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Upload Image
                                  </label>
                                  <div className="row">
                                    <div className="col-xxl-10 col-xl-10 col-lg-9 col-md-9 col-sm-8 col-8">
                                      {isDisable ? (
                                        false
                                      ) : (
                                        <input
                                          type="file"
                                          multiple
                                          name="imageGallery"
                                          className="form-control"
                                          onChange={(e) =>
                                            handlemultiplefile(e)
                                          }
                                          style={{ fontSize: "19px" }}
                                        />
                                      )}
                                    </div>
                                    <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-3 col-sm-4 col-4">
                                      <div className="ms-auto">
                                        <button
                                          className="btn btn-outline-primary btn-md me-2"
                                          type="button"
                                          onClick={() => handleupload()}
                                        >
                                          {" "}
                                          Upload Gallery{" "}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex flex-wrap mt-3">
                                  {imageGallery.length > 0 &&
                                    imageGallery.map((item, index) => {
                                      const isVideo = (
                                        item.previewUrl
                                          ? item.file.name
                                          : item.mediaURL
                                      )?.match(/\.(mp4|webm|ogg)$/i); // checks file extension

                                      return (
                                        <div
                                          key={index}
                                          className="position-relative m-2"
                                        >
                                          {isVideo ? (
                                            <video
                                              width={120}
                                              height={66}
                                              autoPlay
                                              // controls
                                              className="rounded border"
                                            >
                                              <source
                                                src={
                                                  item.previewUrl
                                                    ? item.previewUrl
                                                    : item?.ID > 0
                                                      ? Imageurl + item.mediaURL
                                                      : NoImage
                                                }
                                                type="video/mp4"
                                              />
                                              Your browser does not support the
                                              video tag.
                                            </video>
                                          ) : (
                                            <img
                                              src={
                                                item.previewUrl
                                                  ? item.previewUrl
                                                  : item?.ID > 0
                                                    ? Imageurl + item.mediaURL
                                                    : NoImage
                                              }
                                              alt="Gallery"
                                              className="rounded border"
                                              width={100}
                                              height={100}
                                            />
                                          )}

                                          <button
                                            className="btn btn-danger btn-sm position-absolute top-0 end-0"
                                            type="button"
                                            onClick={() => {
                                              handleRemoveImage(item, index);
                                            }}
                                          >
                                            X
                                          </button>
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Subscription */}
                      {/* <div className="accordion-item">
                  <div className="accordion-header" id="headingFour">
                    <div
                      className="accordion-button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="true"
                      aria-controls="collapseFour"
                    >
                      <div className="text-editor add-list">
                        <div className="addproduct-icon list">
                          <h5>
                            <List className="add-info" />
                            <span> Subscrption</span>
                          </h5>
                          <Link to="#">
                            <ChevronDown className="chevron-down-add" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFour"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="row pb-4">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3">
                            <label className="form-label">
                              Subscrption Plan
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <Select
                              classNamePrefix="react-select"
                              options={permissiontemplateoption}
                              name="permissiontemplate"
                              value={permissiontemplateoption?.find(
                                (el) => el.value == formvalue.permissiontemplate
                              )}
                              onChange={(e) =>
                                Handleselect(e, "permissiontemplate")
                              }
                              placeholder="Choose"
                              isDisabled={isDisable || userData?.businessId > 0}
                            />
                            {errors.permissiontemplate && (
                              <div style={{ color: "red" }}>
                                {errors.permissiontemplate}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3">
                            <label className="form-label">
                              How did you hear about BookYarra ?
                            </label>
                            <Select
                              classNamePrefix="react-select"
                              options={hearAboutOption}
                              name="marketviews"
                              value={hearAboutOption?.find(
                                (el) => el.value == formvalue.marketviews
                              )}
                              onChange={(e) => Handleselect(e, "marketviews")}
                              placeholder="Choose"
                              isDisabled={isDisable}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}

                      {/* Opening Hours */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingSeven">
                          <div
                            className="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseSeven"
                            aria-expanded="true"
                            aria-controls="collapseSeven"
                          >
                            <div className="text-editor add-list">
                              <div className="addproduct-icon list">
                                <h5>
                                  <List className="add-info" />
                                  <span>Opening Hours  </span>
                                </h5>
                                <div className="d-flex align-items-center gap-2">
                                  <span className="step-text">Step 8</span>
                                  <ChevronDown className="chevron-down-add" />
                                </div>
                                {/* <Link to="#">
                                  <ChevronDown className="chevron-down-add" />
                                </Link> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="collapseSeven"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingSeven"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            {/* <div className="row"> */}
                            {/* here is the business hours logic where the business admin can set the day wise start time and end time. */}
                            {/* in this section have a day wise show start and end time and admin can edit it  by selecting a hours from morning 12:00 to 24:00 give it to teh range it every 5 min  of the day make ir array. */}
                            {/* </div> */}

                            <BusinessHours
                              minHoursDropdown={minHoursDropdown}
                              workingHours={businessHours}
                              onChange={handleBusinessHoursChange}
                              businessListDisable={isDisable}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Business Schedule */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingNine">
                          <div
                            className="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseNine"
                            aria-expanded="true"
                            aria-controls="collapseNine"
                          >
                            <div className="text-editor add-list">
                              <div className="addproduct-icon list">
                                <h5>
                                  <List className="add-info" />
                                  <span>Holiday Schedule {"(Optional)"}</span>
                                </h5>
                                <div className="d-flex align-items-center gap-2">
                                  <span className="step-text">Step 9</span>
                                  <ChevronDown className="chevron-down-add" />
                                </div>
                                {/* <Link to="#">
                                  <ChevronDown className="chevron-down-add" />
                                </Link> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="collapseNine"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingNine"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <BusinessHoursByDate
                              minHoursDropdown={minHoursDropdown}
                              userData={userData}
                              businessId={businessId}
                              getStaffWiseScheduleRefresh={
                                getStaffWiseScheduleRefresh
                              }
                              isDisable={isDisable}
                            />
                          </div>
                        </div>
                      </div>

                      {/* BusinessHoursTeamShiftManage */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingEight">
                          <div
                            className="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseEight"
                            aria-expanded="true"
                            aria-controls="collapseEight"
                          >
                            <div className="text-editor add-list">
                              <div className="addproduct-icon list">
                                <h5>
                                  <List className="add-info" />
                                  <span>Staff Shift </span>
                                </h5>
                                <div className="d-flex align-items-center gap-2">
                                  <span className="step-text">Step 10</span>
                                  <ChevronDown className="chevron-down-add" />
                                </div>
                                {/* <Link to="#">
                                  <ChevronDown className="chevron-down-add" />
                                </Link> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="collapseEight"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingEight"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <BusinessHoursTeamShiftManage
                              minHoursDropdown={minHoursDropdown}
                              daysDropdown={daysDropdown}
                              userData={userData}
                              businessId={businessId}
                              staffApiRefresh={staffApiRefresh}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Additional Information */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingEleven">
                          <div
                            className="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseEleven"
                            aria-expanded="true"
                            aria-controls="collapseEleven"
                          >
                            <div className="text-editor add-list">
                              <div className="addproduct-icon list icon">
                                <h5>
                                  <LifeBuoy className="add-info" />
                                  <span>Additional Information {"(Optional)"} </span>
                                </h5>
                                <div className="d-flex align-items-center gap-2">
                                  <span className="step-text">Step 11</span>
                                  <ChevronDown className="chevron-down-add" />
                                </div>
                                {/* <Link to="#">
                                  <ChevronDown className="chevron-down-add" />
                                </Link> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="collapseEleven"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingEleven"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <div className="row">
                              <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    QRCode Url
                                  </label>
                                  <input
                                    type="text"
                                    name="QRCodeUrl"
                                    className="form-control"
                                    value={formvalue.QRCodeUrl}
                                    onChange={HandleChange}
                                    readOnly={isDisable}
                                  />
                                </div>
                              </div>

                              <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    GoogleMap Url
                                  </label>
                                  <input
                                    type="text"
                                    name="GoogleMapUrl"
                                    className="form-control"
                                    value={formvalue.GoogleMapUrl}
                                    onChange={HandleChange}
                                    readOnly={isDisable}
                                  />
                                </div>
                              </div>

                              <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="mb-3">
                                  <label className="form-label">Menu Url</label>
                                  <input
                                    type="text"
                                    name="ManuUrl"
                                    className="form-control"
                                    value={formvalue.ManuUrl}
                                    onChange={HandleChange}
                                    readOnly={isDisable}
                                  />
                                </div>
                              </div>

                              {/* <div className="row pb-4"> */}
                              <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Appointment Url
                                  </label>
                                  <input
                                    type="text"
                                    name="AppoimentUrl"
                                    className="form-control"
                                    value={formvalue.AppoimentUrl}
                                    onChange={HandleChange}
                                    readOnly={isDisable}
                                  />
                                </div>
                              </div>

                              <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Online Order Url
                                  </label>
                                  <input
                                    type="text"
                                    name="OnlineOrderUrl"
                                    className="form-control"
                                    value={formvalue.OnlineOrderUrl}
                                    onChange={HandleChange}
                                    readOnly={isDisable}
                                  />
                                </div>
                              </div>
                            </div>
                            {/* </div> */}
                          </div>
                        </div>
                      </div>

                      {/* Select Franchise */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingTwelve">
                          <div
                            className="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwelve"
                            aria-expanded="true"
                            aria-controls="collapseTwelve"
                          >
                            <div className="text-editor add-list">
                              <div className="addproduct-icon list icon">
                                <h5>
                                  <LifeBuoy className="add-info" />
                                  <span>Select Franchise {"(Optional)"} </span>
                                </h5>
                                <div className="d-flex align-items-center gap-2">
                                  <span className="step-text">Step 12</span>
                                  <ChevronDown className="chevron-down-add" />
                                </div>
                                {/* <Link to="#">
                                  <ChevronDown className="chevron-down-add" />
                                </Link> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="collapseTwelve"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingTwelve"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <div className="row pb-4">
                              <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <label className="form-label">
                                  Select Business Franchise{" "}
                                </label>
                                <Select
                                  classNamePrefix="react-select"
                                  options={businessList}
                                  name="businessFranchise"
                                  value={businessList?.filter(
                                    (el) =>
                                      formvalue?.businessFranchise
                                        ?.split(",")
                                        ?.includes(String(el.value)) // Convert to string for comparison
                                  )}
                                  isMulti={true}
                                  onChange={(e) =>
                                    Handleselect(e, "businessFranchise")
                                  }
                                  placeholder="Choose"
                                  isDisabled={isDisable}
                                  styles={customStyles}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* About As Information */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingThirteen">
                          <div
                            className="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThirteen"
                            aria-expanded="true"
                            aria-controls="collapseThirteen"
                          >
                            <div className="text-editor add-list">
                              <div className="addproduct-icon list icon">
                                <h5>
                                  <LifeBuoy className="add-info" />
                                  <span>About As {"(Optional)"}</span>
                                </h5>
                                <div className="d-flex align-items-center gap-2">
                                  <span className="step-text">Step 13</span>
                                  <ChevronDown className="chevron-down-add" />
                                </div>
                                {/* <Link to="#">
                                  <ChevronDown className="chevron-down-add" />
                                </Link> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="collapseThirteen"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingThirteen"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <div className="row pb-5">
                              <CommonTextEditor
                                onChange={(value) => HandleChange(value)}
                                value={formvalue.AboutAs}
                                name="AboutAs"
                                businessListDisable={isDisable}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Term And Condition  Information */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingFourteen">
                          <div
                            className="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFourteen"
                            aria-expanded="true"
                            aria-controls="collapseFourteen"
                          >
                            <div className="text-editor add-list">
                              <div className="addproduct-icon list icon">
                                <h5>
                                  <LifeBuoy className="add-info" />
                                  <span>Terms And Conditions {"(Optional)"}</span>
                                </h5>
                                <div className="d-flex align-items-center gap-2">
                                  <span className="step-text">Step 14</span>
                                  <ChevronDown className="chevron-down-add" />
                                </div>
                                {/* <Link to="#">
                                  <ChevronDown className="chevron-down-add" />
                                </Link> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="collapseFourteen"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingFourteen"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <div className="row pb-4">
                              <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    Appointment cancelled before (in hours)
                                  </label>
                                  <input
                                    type="number"
                                    name="appointmentCancelledBefore"
                                    className="form-control"
                                    value={formvalue.appointmentCancelledBefore || ""}
                                    onChange={HandleChange}
                                    readOnly={isDisable}
                                    min="0"
                                    placeholder="Enter hours"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row pb-5">
                              <CommonTextEditor
                                onChange={(value) => HandleChange(value)}
                                value={formvalue.TermAndCondition}
                                name="TermAndCondition"
                                businessListDisable={isDisable}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Health And Safety Attributes  Information */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingFifteen">
                          <div
                            className="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFifteen"
                            aria-expanded="true"
                            aria-controls="collapseFifteen"
                          >
                            <div className="text-editor add-list">
                              <div className="addproduct-icon list icon">
                                <h5>
                                  <LifeBuoy className="add-info" />
                                  <span>Health And Safety Attributes {"(Optional)"}</span>
                                </h5>
                                <div className="d-flex align-items-center gap-2">
                                  <span className="step-text">Step 15</span>
                                  <ChevronDown className="chevron-down-add" />
                                </div>
                                {/* <Link to="#">
                                  <ChevronDown className="chevron-down-add" />
                                </Link> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="collapseFifteen"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingFifteen"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <div className="row pb-5">
                              <CommonTextEditor
                                onChange={(value) => HandleChange(value)}
                                value={formvalue.HealthAndSafetyAttributes}
                                name="HealthAndSafetyAttributes"
                                businessListDisable={isDisable}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/*Accessibility Features  Information */}
                      <div className="accordion-item">
                        <div className="accordion-header" id="headingSixteen">
                          <div
                            className="accordion-button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseSixteen"
                            aria-expanded="true"
                            aria-controls="collapseSixteen"
                          >
                            <div className="text-editor add-list">
                              <div className="addproduct-icon list icon">
                                <h5>
                                  <LifeBuoy className="add-info" />
                                  <span>Accessibility Features {"(Optional)"}</span>
                                </h5>
                                <div className="d-flex align-items-center gap-2">
                                  <span className="step-text">Step 16</span>
                                  <ChevronDown className="chevron-down-add" />
                                </div>
                                {/* <Link to="#">
                                  <ChevronDown className="chevron-down-add" />
                                </Link> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          id="collapseSixteen"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingSixteen"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <div className="row pb-5">
                              <CommonTextEditor
                                onChange={(value) => HandleChange(value)}
                                value={formvalue.AccessibilityFeatures}
                                name="AccessibilityFeatures"
                                businessListDisable={isDisable}
                              />
                            </div>
                          </div>
                        </div>
                      </div>                      
                    </>
                  )}
                </div>
              </div>
            </div>
            {isDisable || businessId === 0 ? (
              false
            ) : (
              <div className="col-lg-12">
                <div className="btn-addproduct mb-4">
                  <button
                    type="button"
                    className="btn btn-outline-primary me-2 btn-md"
                  >
                    Cancel
                  </button>
                  {businessOnNordingPermmision && (
                    <button type="submit" className="btn btn-submit btn-md">
                      Save Business
                    </button>
                  )}
                </div>
              </div>
            )}
          </form>
          {/* /add */}
        </div>
      </div>
    </>
  );
};

export default BusinessOnboarding;
